import { Alert, AlertProps, Card, Flex, theme } from 'antd';
import { FC, ReactNode } from 'react';

type Props = {
  type: AlertProps['type'];
  content: ReactNode;
  boxShadow?: boolean;
}

export const AddressChangerBadgeAlertOrCard: FC<Props> = ({ type, content, boxShadow = false }) => {
  const {
    token: { boxShadow: bs }
  } = theme.useToken();

  if (type === undefined || type === 'success' || type === 'error') {
    return (
      <Card size="small" style={{ minWidth: 218 }} styles={{ body: { paddingBlock: 4, boxShadow: boxShadow ? bs : undefined } }}>
        <Flex gap={ 4 } align="center">
          <>{ content }</>
        </Flex>
      </Card>
    );
  } else {
    return (
      <Alert
        style={{ paddingBlock: 4, boxShadow: boxShadow ? bs : undefined, minWidth: 218 }}
        type={ type }
        message={ content }
      />
    );
  }
};
